"use client";
import { HeroHeader } from "@/components/HeroHeader/HeroHeader";
import { Heading } from "@/components/Heading/Heading";
import { Layout } from "@/components/Layout/Layout";
import { ThoughtLeadershipCard } from "@/components/ThoughtLeadershipCard/ThoughtLeadershipCard";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { getAbsoluteUrl } from "@/app/utils/getAbsoluteUrl";
import { serialize } from "@/app/utils/generateHTML";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";

import {
    EmailShareButton,
    FacebookShareButton,
    InstapaperShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from "react-share";
import dayjs from "dayjs";
export default function Wrapper({ data, related }) {
    return (
        <Layout lightHeader={false}>
            <HeroHeader heading={data.title} />

            <section className="pb-16">
                <div className="hp-container flex flex-col items-center">
                    {/* {data.image ? (
                        <Image
                            alt="Image"
                            src={getImageSrc(data.image.url)}
                            width={280}
                            height={140}
                            unoptimized
                            className="h-auto w-full rounded-[20px]"
                        />
                    ) : (
                        <></>
                    )} */}
                    <div className="lg:px-8 w-full py-12">
                        <div className="flex gap-8 items-center w-full">
                            <div className="flex gap-2 items-center flex-shrink-0">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6 text-primary"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
                                    />
                                </svg>
                                <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">
                                    {dayjs(data.publishDate).format(
                                        "D MMM YYYY"
                                    )}
                                </span>
                            </div>
                            <div className="flex gap-4 items-center">
                                <span className="text-[14px] lg:text-[16px] xl:text-[18px]  font-bold">
                                    Share
                                </span>
                                <div className="flex gap-2">
                                    <FacebookShareButton
                                        url={getAbsoluteUrl(
                                            `/thought-leadership/${data.slug}`
                                        )}
                                        quote={data.title}
                                    >
                                        <div className="w-8 h-8 border border-white flex items-center justify-center rounded-full bg-blue">
                                            <FaFacebookF className="w-4 h-4 text-primary" />
                                        </div>
                                    </FacebookShareButton>

                                    <TwitterShareButton
                                        url={getAbsoluteUrl(
                                            `/thought-leadership/${data.slug}`
                                        )}
                                        quote={data.title}
                                    >
                                        <div className="w-8 h-8 border border-white flex items-center justify-center rounded-full bg-blue">
                                            <FaXTwitter className="w-4 h-4 text-primary" />
                                        </div>
                                    </TwitterShareButton>

                                    <LinkedinShareButton
                                        url={getAbsoluteUrl(
                                            `/thought-leadership/${data.slug}`
                                        )}
                                        quote={data.title}
                                    >
                                        <div className="w-8 h-8 border border-white flex items-center justify-center rounded-full bg-blue">
                                            <FaLinkedinIn className="w-4 h-4 text-primary" />
                                        </div>
                                    </LinkedinShareButton>

                                    <WhatsappShareButton
                                        url={getAbsoluteUrl(
                                            `/thought-leadership/${data.slug}`
                                        )}
                                        quote={data.title}
                                    >
                                        <div className="w-8 h-8 border border-white flex items-center justify-center rounded-full bg-blue">
                                            <FaWhatsapp className="w-4 h-4 text-primary" />
                                        </div>
                                    </WhatsappShareButton>
                                </div>
                            </div>
                        </div>
                        <div className="post-content">
                            {serialize(data.content)}
                        </div>
                    </div>
                    <div className="flex flex-col w-full items-start gap-8">
                        <Heading>Related Articles</Heading>
                        <div className="w-full grid grid-cols-1 items-center border-t border-[#D9D9D9]">
                            {related.docs?.map((news, key) => {
                                return (
                                    <ThoughtLeadershipCard
                                        image={
                                            news.image
                                                ? getImageSrc(news.image.url)
                                                : null
                                        }
                                        title={news.title}
                                        date={dayjs(news.publishDate).format(
                                            "D MMM YYYY"
                                        )}
                                        slug={news.slug}
                                        key={key}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}
